"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../../../constants/spacing"));

var _breakpoints = _interopRequireDefault(require("../../../../constants/breakpoints"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-top: ", ";\n\tmargin-bottom: ", ";\n\tborder-bottom: 1px solid ", ";\n\n\t@media (max-width: ", ") {\n\t\tdisplay: none;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var TitleUnderline = _styledComponents.default.div(_templateObject(), _spacing.default.s1, _spacing.default.s2, _colors.default.grey, _breakpoints.default.largeMobile);

TitleUnderline.displayName = 'TitleUnderline';
/** @component */

var _default = TitleUnderline;
exports.default = _default;